export default __webpack_public_path__ + "static/media/Roboki.f8ad34bd.png";